function handleItemClick(event) {
	// Remove 'selected' class from any previously selected item
	const currentlySelected = document.querySelector('.cd-faq-categories-mobile .selected');
	if (currentlySelected) {
			currentlySelected.classList.remove('selected');
	}

	// Add 'selected' class to the clicked item
	event.currentTarget.classList.add('selected');
}

// Function to clone the links into a new ul
function cloneLinksIntoNewUl() {
	const links = document.querySelectorAll('.cd-faq-categories a');

	// Create a new ul element
	const newUl = document.createElement('ul');
	const newDiv = document.createElement('div');
	newDiv.classList.add('cd-faq-categories-mobile-wrapper'); // Add a class for identification
	newUl.classList.add('cd-faq-categories-mobile'); // Add a class for identification

	// Loop through each link and clone it into a new li element inside the new ul
	links.forEach((link) => {
			const newLi = document.createElement('li'); // Create a new li element
			const clone = link.cloneNode(true); // Clone the link
			newLi.appendChild(clone); // Append the cloned link to the new li
			newUl.appendChild(newLi); // Append the new li to the new ul
			newDiv.appendChild(newUl); // Append the new li to the new ul
	});

	// Get the original ul element
	const originalUl = document.querySelector('.cd-faq-categories');

	// Insert the new ul after the original ul
	originalUl.parentNode.insertBefore(newDiv, originalUl.nextSibling);

	const items = document.querySelectorAll('.cd-faq-categories-mobile li');

	items.forEach((item) => {
			item.addEventListener('click', handleItemClick);
	});
}

// Create a new MutationObserver instance
const observer = new MutationObserver((mutationsList, observer) => {
	// Check if the ul.cd-faq-categories element is in the DOM
	const faqCategories = document.querySelector('.cd-faq-categories');
	if (faqCategories) {
			// If the element is found, clone the links into a new ul
			cloneLinksIntoNewUl();

			// Stop observing once the target element is found
			observer.disconnect();
	}
});

// Start observing the document for changes
observer.observe(document.body, {
	childList: true, // Watch for the addition/removal of child nodes
	subtree: true, // Also watch for changes in all descendant nodes
});

// // Funktion, um die Margin-Top basierend auf dem Scrollen und Header-Status dynamisch anzupassen
// function adjustMarginOnScroll() {
// 	const header = document.querySelector(".section-header");
// 	const faqCategories = document.querySelector('.cd-faq-categories');
// 	const faqItems = document.querySelector('.cd-faq-items');

// 	// Überprüfen, ob der Header die Klasse 'scrolled-past-header' hat
// 	if (header.classList.contains('scrolled-past-header')) {
// 			if (header.classList.contains('shopify-section-header-hidden')) {
// 					// Wenn die Header-Klasse 'shopify-section-header-hidden' vorhanden ist, die Margin-Top auf 0px setzen
// 					faqCategories.style.setProperty('margin-top', '0px', 'important');
// 			} else {
// 					// Der Offset des Containers vom oberen Rand des Dokuments
// 					const containerOffsetTop = faqItems.getBoundingClientRect().top + window.scrollY;
	
// 					// Der aktuelle Scroll-Offset
// 					const scrollTop = window.scrollY;

// 					// Der Abstand des Containers zum oberen Rand des sichtbaren Bereichs
// 					const distanceToTop = containerOffsetTop - scrollTop;
// 					if(distanceToTop > 0 ) {
// 						distanceToTop = 0;
// 					}

// 					// Berechne die neue Margin-Top
// 					let newMarginTop = 100; // Startwert in px
// 					console.log(distanceToTop)
// 					if (distanceToTop > -100 ) {
// 							// Berechne die Margin-Top basierend auf der Entfernung zum oberen Rand
// 							newMarginTop = -distanceToTop;
// 					} 
			
					
// 					// Setze die berechnete Margin-Top, sicherstellen, dass !important verwendet wird
// 					faqCategories.style.setProperty('margin-top', `${newMarginTop}px`, 'important');
// 			}
// 	} else {
// 			// Wenn die Header-Klasse 'scrolled-past-header' nicht vorhanden ist, die Margin-Top auf 0px setzen
// 			faqCategories.style.setProperty('margin-top', '0px', 'important');
// 	}
// }


// // Event-Listener für das Scrollen hinzufügen
// window.addEventListener('scroll', adjustMarginOnScroll);

// Funktion, um den Header-Status zu überprüfen und die .cd-faq-categories zu modifizieren
function checkHeaderAndModify() {
	
	const header = document.querySelector(".section-header");
	const faqCategories = document.querySelector('.cd-faq-categories');

	if (header.classList.contains('scrolled-past-header') ) {
		if(header.classList.contains('shopify-section-header-hidden') )
		{
			faqCategories.classList.remove('movedown')

		}
		else{

			faqCategories.classList.add('movedown')
		}

} 
else{
	faqCategories.classList.remove('movedown')

}

}
window.addEventListener('scroll', checkHeaderAndModify);

function addStyleAfterLinkIsAdded() {
	const observer = new MutationObserver((mutationsList, observer) => {
			for (let mutation of mutationsList) {
					if (mutation.type === 'childList') {
							// Check if a link element containing 'default.css' in the href has been added
							const addedNodes = Array.from(mutation.addedNodes);
							for (let node of addedNodes) {
									if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'LINK') {
											const linkHref = node.getAttribute('href');
											if (linkHref && linkHref.includes('default.css')) {
													// A link containing 'default.css' has been added, now we add the style
													addCustomStyleAfterLink(node);
													// Stop observing since the task is complete
													observer.disconnect();
													break;
											}
									}
							}
					}
			}
	});

	function checkIfFixed() {
		// Select the div with class 'cd-faq-categories'
		var faqCategoriesDiv = document.querySelector('.cd-faq-categories');

		// Check if the div has the class 'is-fixed'
		if (faqCategoriesDiv.classList.contains('is-fixed')) {
			faqCategoriesDiv.classList.remove('moveup')		} 
			else {
				if (faqCategoriesDiv.classList.contains('movedown')) {
				faqCategoriesDiv.classList.add('moveup')
			}
			else{
				faqCategoriesDiv.classList.remove('moveup')	
			}
		}
}

// Add the scroll event listener to the window
window.addEventListener('scroll', checkIfFixed);

	// Start observing the document for added nodes (i.e., DOM changes)
	observer.observe(document.documentElement, { childList: true, subtree: true });

	function addCustomStyleAfterLink(linkElement) {
			const style = document.createElement('style');
			style.innerHTML = `
			/* faq style overwrites */
			.cd-faq-categories .selected, .cd-faq-categories-mobile .selected {
					background: #F8F8FB !important;
			}
			@media only screen and (min-width: 1024px) {
					.cd-faq-categories .selected, .cd-faq-categories-mobile .selected {
							background: #F8F8FB !important;
					}
			}
			.cd-faq-categories-mobile .selected li {
					border-radius: 8px;
					border: 1px solid #EBF0F9 !important;
			}
			.cd-faq-categories-mobile-wrapper {
					display: none !important;
					
			}
					.tt-menu{
					    z-index: 999!important;
							}
			@media (max-width: 768px) {
					.cd-faq-categories-mobile {
							display: flex !important;
							overflow-x: scroll;
							gap: 8px;
							padding-left: 24px !important;
							padding-right: 24px !important;
					}
					.ddshop-search-widget {
							padding-left: 24px;
							padding-right: 24px;
					}
					.cd-faq-items {
							padding-left: 24px;
							padding-right: 24px;
					}
					.cd-faq-categories-mobile-wrapper {
							display: block !important;
							background: white !important;
							z-index: 998;
							position: sticky;
							top: 0;
					}
					.cd-faq-group {
							z-index: 0;
							scroll-margin: 7em;
					}
					.cd-faq-categories-mobile li {
							margin-top: 0.5em !important;
							padding: 8px 16px !important;
							border: 1px solid #EBF0F9 !important;
							border-radius: 4px !important;
							color: #0F1F41 !important;
					}
					.cd-faq-categories-mobile li a {
							color: #0F1F41 !important;
							font-size: 15px !important;
					}
					.cd-faq-categories a {
							font-size: 15px !important;
							padding: 0 16px !important;
					}
			}
			.cd-faq-categories a:hover {
					background: #F5F5FB !important;
			}
			.bootstrap-ddshop a {
					text-decoration: underline !important;
			}
			.cd-faq-categories-mobile a {
					text-decoration: none !important;
			}
			.cd-faq-categories a {
					text-decoration: none !important;
			}
			.ddshop-faq-question {
					font-weight: 600 !important;
			}
			.activeItem h4 {
					background: #0F1F41 !important;
					color: white !important;
			}
			.forceVisible {
					display: block !important;
			}
			.cd-faq-content {
					padding-top: 1em !important;
			}
	.cd-faq-categories.moveup{
		margin-top: -100px!important;
		transition: all 0.3s ease;
			}

			.cd-faq-categories.movedown{
		top: 100px!important;
			}
		
	.activeItem	.cd-faq-trigger::after{
		background:white!important;
				transform: scaleY(-1);
		}
	.activeItem	.cd-faq-trigger::before{
		background:white!important;
				transform: scaleY(-1);
		}
			`;
			// Insert the style tag after the linkElement
			linkElement.parentNode.insertBefore(style, linkElement.nextSibling);
	}
}

// Call the function to start observing and adding the style when the link is added
addStyleAfterLinkIsAdded();

function initSearch() {
	// Entferne alle bisherigen Handler für 'typeahead:select'
	$('#ddshop-search-query').off('typeahead:select');

	// Füge einen neuen Handler für 'typeahead:select' hinzu
	$('#ddshop-search-query').on('typeahead:select', function (ev, suggestion) {
			ev.stopImmediatePropagation(); // Stoppt alle anderen Event-Listener
			ev.preventDefault(); // Verhindert das Standardverhalten

			// Entferne das Highlighting von allen zuvor markierten FAQ-Elementen und verstecke alle Antworten
			// $('.cd-faqitem').removeClass('activeItem');
			// $('.cd-faq-content').slideUp(200); // Verstecke alle Antworten mit Animation

			// Gehe davon aus, dass 'suggestion.id' die ID des FAQ-Elements ist
			var faqId = suggestion.id;

			// Finde das entsprechende FAQ-Element und füge die 'activeItem' Klasse hinzu
			var selectedFaq = $('#faq-question-' + faqId).closest('.cd-faqitem');
			selectedFaq.addClass('activeItem');
			var selectedAnswer = selectedFaq.find('.cd-faq-content');
			selectedAnswer.slideDown(200); // Zeige die Antwort mit Animation

			// Optional: Scrolle zu dem markierten Element (kann entfernt werden, wenn nicht gewünscht)
			$('html, body').animate({
					scrollTop: selectedFaq.offset().top - 100 // Anpassung für die Höhe der Navigation
			}, 200); // Dauer des Scrollens
	});

	// Füge einen Click-Handler zu den FAQ-Fragen hinzu
	$('.cd-faqitem h4').click(function (ev) {
			ev.stopImmediatePropagation(); // Stoppt alle anderen Event-Listener
			ev.preventDefault(); // Verhindert das Standardverhalten

			var $parent = $(this).parent().parent();
			var $content = $parent.find(".cd-faq-content");

			if ($parent.hasClass('activeItem')) {
					// Wenn das aktuelle Element aktiv ist, schließe es
					$parent.removeClass('activeItem');
					$content.slideUp(200); // Verstecke die Antwort mit Animation
			} else {
					// Wenn das aktuelle Element nicht aktiv ist, schließe alle anderen und öffne das aktuelle
					// $('.cd-faqitem').removeClass('activeItem');
					// $('.cd-faq-content').slideUp(200); // Verstecke alle Antworten mit Animation

					$parent.addClass('activeItem');
				// 	$('html, body').animate({
				// 		scrollTop: $(this).offset().top - 100 // Anpassung für die Höhe der Navigation
				// }, 200); // Dauer des Scrollens
					$content.slideDown(200); // Zeige die Antwort mit Animation

			}


	});

	// Create a new MutationObserver instance to monitor when .tt-menu is added to the DOM
	const observerMenu = new MutationObserver((mutationsList, observer) => {
			mutationsList.forEach(mutation => {
					if (mutation.type === 'childList') {
							// Check if the .tt-menu element is now in the DOM
							const searchMenu = document.querySelector('.tt-menu');
							if (searchMenu) {
									// Start observing changes within the .tt-menu element
									observerSearchResults(searchMenu);

									// Disconnect this observer since .tt-menu is now in the DOM
									observer.disconnect();
							}
					}
			});
	});

	// Start observing the body for changes in the DOM to detect when .tt-menu is added
	observerMenu.observe(document.body, {
			childList: true,
			subtree: true
	});
}

function observerSearchResults(searchMenu) {
	// Create a new MutationObserver instance to monitor changes within the .tt-menu
	const observerSearch = new MutationObserver((mutationsList, observer) => {
			mutationsList.forEach(mutation => {
					if (mutation.type === 'childList') {
							// Check if there are any suggestions in the search results
							const searchResults = document.querySelectorAll('.tt-suggestion');

							if (searchResults.length > 0) {
									handleSearchbar();
							} else {
								// If "Nothing found." is present, replace its text
								const noResultsMessage = searchMenu.querySelector('.list-group-item');
						
								if (noResultsMessage && noResultsMessage.textContent.trim() === 'Nothing found.') {
										// Create a new <a> element
										const contactLink = document.createElement('a');
										contactLink.href = 'https://gardia.net/pages/kontakt';  // Ersetze dies mit der tatsächlichen Kontakt-E-Mail oder URL
										contactLink.textContent = 'kontaktieren Sie uns';
						
									
										// Alternatively, if you want to append the link directly without HTML injection:
										noResultsMessage.innerHTML = 'Keine Ergebnisse gefunden. Für weitere Informationen oder Unterstützung ';
										noResultsMessage.appendChild(contactLink);
										noResultsMessage.innerHTML += '.';
								}
						}
						
					}
			});
	});

	// Start observing the .tt-menu for changes in its child elements
	observerSearch.observe(searchMenu, {
			childList: true,
			subtree: true
	});
}

function handleSearchbar() {
	var elements = document.getElementsByClassName("tt-suggestion");

	for (var i = 0; i < elements.length; i++) {
			elements[i].addEventListener('click', searchSuggestionClicked(elements[i]), false);
	}
}

// Initialize the search observer when the page is ready
document.addEventListener('DOMContentLoaded', initSearch);
